// EXPERIMENT: psf_promote_or_share_qr_code_experiment — remove with experiment cleanup
import type { RefObject } from 'react';

import { SocialSharing } from '@change/ds-core-ui';
import { QrCodeIcon } from '@change/ds-icons/QrCodeIcon';
import { cn } from '@change/ds-utils';

import { useI18n } from '@change-corgi/core-react/i18n';

import { SHARE_ICON_SIZE_CLASSNAME } from '../../constants';

/**
 * EXPERIMENT: psf_promote_or_share_qr_code_experiment.
 * The "QR code" tile after the channel tiles. Not a share channel: it shares nothing and only opens
 * the QR view, so it renders the DS button directly instead of going through a share config. The
 * wrapper (`contents`, so the tile stays the grid item) gives `tileRef` an element to find the
 * tile's button in.
 */
export const QrCodeTile = ({
	onPress,
	tileRef,
}: {
	onPress: () => void;
	tileRef: RefObject<HTMLDivElement | null>;
}) => {
	const { translate } = useI18n();
	return (
		<div ref={tileRef} className="contents" data-testid="qr-code-tile">
			<SocialSharing
				icon={<QrCodeIcon />}
				label={translate('corgi.psf.promote_or_share.share_slide_up.qr_code.tile_label')}
				variant="default"
				className={cn(SHARE_ICON_SIZE_CLASSNAME, 'w-full')}
				onClick={onPress}
				data-qa="petition-share-slide-up-grid-qr-code-button"
			/>
		</div>
	);
};
